module.exports = __webpack_public_path__ + "static/img/baiyiCollege.f830465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/baiyiCollege.png
// module id = UMak
// module chunks = 1